











import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'DiscountProgressBar',
  props: {
    title: {
      type: String,
      default: '',
    },
    progress: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
  },
});
